import { render, staticRenderFns } from "./myAccountPage.vue?vue&type=template&id=90366c3c"
import script from "./myAccountPage.vue?vue&type=script&lang=js"
export * from "./myAccountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports